"use client";

import { useEnterprise } from "@/lib/enterprise/EnterpriseProvider";
import { Loader2 } from "lucide-react";
import React from "react";

interface LoadingIconProps {
  size?: number; // Size in pixels
  className?: string;
}

const LoadingDog: React.FC<LoadingIconProps> = ({ size = 24, className }) => {
  const { theme } = useEnterprise();
  const primaryColor = theme?.primaryColor;
  const calculatedSize = (size * size) / 4;

  if (primaryColor) {
    return (
      <Loader2
        className={`animate-spin ${className}`}
        style={{ width: calculatedSize, height: calculatedSize, color: primaryColor }}
      />
    );
  }

  return (
    <img
      src="/loading_dog.png"
      alt="Loading"
      className={`animate-spin ${className}`}
      style={{ width: calculatedSize, height: calculatedSize }}
    />
  );
};

export default LoadingDog;
